var _style, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondWeave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 172 172",
    style: {
      enableBackground: "new 0 0 172 172"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:none;stroke:#565656;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#565656;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:9.9996;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 172,
    height: 172.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,291c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,269.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,280.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 270.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -174.4961 180.7648)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,291c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,269.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,280.2c-13.7,13.9-27.3,27.7-40.9,41.5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 270.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -199.6845 119.9542)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,205c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,183.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,194.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 184.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -113.6166 155.6098)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,205c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,183.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,194.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 184.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -138.8049 94.7992)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,118.9c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,97.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,108.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 98.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -52.7785 130.3547)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,118.9c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,97.5c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,108.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 98.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -77.9669 69.5443)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,32.9c-13.6,13.8-27.2,27.6-40.8,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,11.5c-13.6,13.8-27.2,27.6-40.9,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,22.2c-13.6,13.8-27.2,27.6-40.8,41.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 12.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 8.0303 105.1705)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.9,32.9C62.2,46.7,48.6,60.5,35,74.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,11.5C41.4,25.3,27.8,39.1,14.1,52.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,22.2C52,36,38.4,49.8,24.8,63.6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 12.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -17.158 44.36)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,55.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,76c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,65.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 55.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -34.9698 87.3665)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-8,55.1C5.8,68.7,19.6,82.3,33.4,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-29.4,76c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-18.7,65.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.4,
    y: 55.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -60.1586 26.556)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,55.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,76c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,65.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 55.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.777 148.1753)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78-31c13.8,13.6,27.6,27.3,41.4,40.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6-10.1C70.4,3.5,84.2,17.1,98,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3-20.8C81.1-7.1,94.9,6.5,108.7,20.1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: -30.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 25.839 62.1737)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164-31c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6-10.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3-20.8c13.8,13.7,27.6,27.3,41.4,40.9"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: -30.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 51.0318 122.9825)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-8-31C5.8-17.4,19.6-3.7,33.4,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-29.4-10.1C-15.6,3.5-1.8,17.1,12,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-18.7-20.8C-4.9-7.1,8.9,6.5,22.7,20.1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.4,
    y: -30.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 0.6502 1.3631)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,141.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,162c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,151.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 141.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -95.7786 112.5593)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-8,141.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-29.4,162c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-18.7,151.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.4,
    y: 141.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -120.9674 51.7489)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,227.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,248c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,237.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 227.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -156.5874 137.7523)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-8,227.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-29.4,248c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-18.7,237.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.4,
    y: 227.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -181.7761 76.9417)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,141.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,162c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,151.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 141.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -70.5859 173.3683)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,227.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,248c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,237.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 227.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -131.3947 198.5611)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,313.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,334c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,323.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 313.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -217.5064 163.0207)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-8,313.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-29.4,334c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-18.7,323.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.4,
    y: 313.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -242.6951 102.2103)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,313.1c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.6,334c13.8,13.6,27.6,27.2,41.4,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,323.3c13.8,13.6,27.6,27.2,41.4,40.8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 313.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -192.3137 223.8297)",
    className: "st2",
    width: 60.8,
    height: 60.8
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondWeave);
export default __webpack_public_path__ + "static/media/Diamond-Weave.84a0eb2457fc633631f8605e47bf0f05.svg";
export { ForwardRef as ReactComponent };